import React, { useContext } from "react";
import { AppValue } from "../../../contexts/app";
import Page from "../../../components/page";
import Row from "../../../components/row";
import Column from "../../../components/column";
import Dynamic from "../../../components/dynamic";
import Text from "../../../components/text";
import Image from "../../../components/image";
import List from "../../../components/list";
import Input from "../../../components/input";
import Button from "../../../components/button";
import Map from "../../../components/map";
import Component from "../../../components/component";
import CompPreview from "../../../components/comppreview";
import Floating from "../../../components/floating";
import Icon from "../../../components/icon";
import Popup from "../../../components/popup";
import Dataloader from "../../../components/dataloader";
import Fileupload from "../../../components/fileupload";
import Textarea from "../../../components/textarea";
import Grid from "../../../components/grid";
import Dropdown from "../../../components/dropdown";
const Components = {
  Page,
  Row,
  Column,
  Text,
  Image,
  List,
  Input,
  Button,
  Map,
  Component,
  Floating,
  Icon,
  Popup,
  Dataloader,
  Fileupload,
  Textarea,
  Grid,
  Dropdown,
};

const Render = (props) => {
  const { components } = useContext(AppValue);
  if (Components[props.block.component]) {
    return React.createElement(
      Components[props.block.component],
      { ...props },
      props.block.children
    );
  } else if (props.block.custom) {
    return <CompPreview {...props} />;
  } else {
    return (
      <Dynamic
        {...props}
        block={JSON.stringify(props.block)}
        path={props.path}
      />
    );
  }
};

export default Render;
